import type { ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';
import { type BadgeIconVariants, badgeIconVariants } from './badge-icon-variants';

type BadgeIconProps = BadgeIconVariants & { children: ReactNode; className?: string };

export function BadgeIcon({ tone, className, children }: BadgeIconProps) {
  return (
    <span
      data-slot="badge-icon"
      aria-hidden="true"
      className={cn(badgeIconVariants({ tone }), className)}
    >
      {children}
    </span>
  );
}
